export default "__VITE_ASSET__B__6q8Le__"